/**
 * The AbstractMediator class works as the empty container
 * for the scene controller which maintains the business logic.
 */
const tbs_core_AbstractMediator = function(bridge) {
    // console.log('tbs_core_AbstractMediator constructor')
    if (bridge == null) {
         return
    }
    //--------------------------------------------------
    // private properties
    //--------------------------------------------------
    // The target instance for the scene view
    let _target,
        // The data convertor for the scene
        _convertor,
        // The data translator for the scene
        _translator,
        // The data properties for the scene
        _properties,
        // The parent mediator for the scene
        _parent

    //--------------------------------------------------
    // privileged setter and getter
    //--------------------------------------------------
    /**
     * @privileged setter and getter
     */
    this.p_target = function(value) {
        if (arguments.length > 0) {
            _target = value
        }
        else {
            return _target
        }
    }

    /**
     * @privileged setter and getter
     */
    this.p_convertor = function(value) {
        if (arguments.length > 0) {
            _convertor = value
        }
        else {
            return _convertor
        }
    }

    /**
     * @privileged setter and getter
     */
    this.p_translator = function(value) {
        if (arguments.length > 0) {
            _translator = value
        }
        else {
            return _translator
        }
    }

    /**
     * @privileged setter and getter
     */
    this.p_properties = function(value) {
        if (arguments.length > 0) {
            _properties = value
        }
        else {
            return _properties
        }
    }

    /**
     * @privileged setter and getter
     */
    this.p_parent = function(value) {
        if (arguments.length > 0) {
            _parent = value
        }
        else {
            return _parent
        }
    }
    
    // refer to the bridge
    this._bridge = bridge
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_core_AbstractMediator.prototype = {
    //--------------------------------------------------
    // setter and getter
    //--------------------------------------------------
    /**
     * @getter
     */
    target: function(value) {
        if (arguments.length > 0) {
            this.p_target(value)
        }
        else {
            return this.p_target()
        }
    },
    /**
     * @getter
     */
    convertor: function(value) {
        if (arguments.length > 0) {
            this.p_convertor(value)
        }
        else {
            return this.p_convertor()
        }
    },
    /**
     * @getter
     */
    translator: function(value) {
        if (arguments.length > 0) {
            this.p_translator(value)
        }
        else {
            return this.p_translator()
        }
    },
    /**
     * @getter
     */
    properties: function(value) {
        if (arguments.length > 0) {
            this.p_properties(value)
        }
        else {
            return this.p_properties()
        }
    },
    /**
     * @getter
     */
    parent: function(value) {
        if (arguments.length > 0) {
            this.p_parent(value)
        }
        else {
            return this.p_parent()
        }
    },

    //--------------------------------------------------
    // protected method
    //--------------------------------------------------
    /**
     * @protected
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    onCreationComplete: function() {
        console.log('onCreationComplete')
    },
    /**
     * @protected
     * Handle the data loaded condition triggered by 
     * the scene instance.
     */
    onDataLoaded: function() {
        console.log('onDataLoaded')
    },
    /**
     * @protected
     * Handle the custom event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
    },
    /**
     * @protected
     * Handle the parent event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleParentEvent: function(event) {
        console.log('handleParentEvent', event)
    },
    /**
     * @protected
     * Destroy the loaded module before mediator destroy.
     */
    destroy: function() {
        // console.log('tbs_core_AbstractMediator.destroy')
        // clear the target
        this.p_target(null)
        // clear the convertor
        this.p_convertor(null)
        // clear the translator
        this.p_translator(null)
    }
}

module.exports = tbs_core_AbstractMediator